
export type TagMatchMode = 'all' | 'any'
export type TaggableType = 'employee' | 'shift'

declare const TagIDSymbol: unique symbol
export type TagID = string & { [TagIDSymbol]: never }

export interface TagDto {
    id: string
    name: string
    type: string
}

export interface Tag {
    id: TagID
    name: string
    type: string
}

export const createTag = (
    params: {
        id: TagID,
        name: string,
        type: string,
    }
): Tag => ({
    id: params.id,
    name: params.name,
    type: params.type,
})

export const tagFromDto = (dto: TagDto): Tag => (createTag({
    id: dto.id as TagID,
    name: dto.name,
    type: dto.type,
}))
